import Model from './Model'

export default class Affiliation extends Model {
  code: string
  logoId: number
  title: string
  description: string
  activationDescriptionId: number
  removeDescriptionId: number
  activationDescription: string
  removeDescription: string
  email: string
  phone: string
  json: any

  constructor(json) {
    super({})
    this.json = json
    this.code = json.code
    this.description = json.description
    this.email = json.email
    this.phone = json.phone
  }

  parseAffiliation(locale) {
    this.title = this.json._title[locale]
    this.description = this.json._description[locale]
    this.activationDescription = this.json._activation_description[locale]
    this.removeDescription = this.json._remove_description[locale]
  }
}
